// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__16f9X","author":"Table_author__1azHZ","authorImage":"Table_authorImage__1THC5","unreadRow":"Table_unreadRow__euKtG"};